<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22994 4.57389L13.1177 4.75722M13.1177 4.75722L13.301 11.645M13.1177 4.75722L4.63241 13.2425"
      stroke="currentColor"
      stroke-width="1.6"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
  export default {
    name: 'RedirectIcon',
  };
</script>
